import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ListContainer } from 'components';
import SentMessagesTable from './SentMessagesTable';
import MessageDetails from './MessageDetails';

const SentMessages = () => {
    return (
        <ListContainer>
            <Routes>
                <Route path="details/:id" element={<MessageDetails />} />
                <Route index element={<SentMessagesTable />} />
                <Route path="*" element={<Navigate to="/sent-messages" replace />} />
            </Routes>
        </ListContainer>
    );
};

export default SentMessages;
